import useDisciplinesColumns from './useDisciplinesColumns'

export default useDisciplinesColumns
